import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Response } from '@angular/http/src/static_response';
import {Observable} from 'rxjs/Observable';
import {Headers} from '@angular/http';
import { environment } from '../environments/environment';
@Injectable()
export class MediaService {
  
  media_type: string;

  get_media_url: string;

  update_media_url: string;

  page_number: number;

  max_pages: number;

  baseurl: string;

  nones: string;



  constructor(private http: Http) {
    this.baseurl = (<any>window).config.baseurl;
    this.nones = (<any>window).config.nones;
    this.get_media_url = this.baseurl+'/wp-json/dvin508-seo/v1/media/missing';
    this.update_media_url = this.baseurl+'/wp-json/dvin508-seo/v1/update_media';
    this.page_number = 1;

  }


  /* get media list of any type of media */
  get_media_list(){

    return this.http.get(this.get_media_url+'/'+this.media_type+'/'+this.page_number,
                          { headers: new Headers({ 'X-WP-Nonce': this.nones }) }
            );
  
  }

  /* change type of media and reset page number to 1 so new type is initialized from 1*/
  reset_media_type(media_type){

    this.page_number = 1; // setting page number to 1 will make sure we are loading new type with page 1
    
    this.media_type = media_type;

  }

  next_page(){
    if((this.page_number+1) <= this.max_pages){
      this.page_number = this.page_number + 1;
      return true;
    }
    return false;
  }

  previous_page(){
    if((this.page_number) > 1){
      this.page_number = this.page_number - 1;
      return true;
    }
    return false;
  }

  update_media(media){
    return this.http.post(
      this.update_media_url,
      JSON.stringify(media),
      { headers: new Headers({ 'Content-Type': 'application/json', 'X-WP-Nonce': this.nones}) }
    )
  }

}



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/media.service.ts